import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}/sign-url/{personId}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const generateSignerUrl = async ({ eSignatureRequestId, personId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/e-signature-requests/${eSignatureRequestId}/sign-url/${personId}`);
  return response.data;
};

export default generateSignerUrl;
